export default "__VITE_ASSET__CLVgoBtY__"